import { ReactElement } from 'react';
import { ModalOverlay, CloseButton } from '../FormModal/styles';
import { useModalControl } from 'hooks/useModalControl';
import { CloseModalX, Trash3Icon } from 'icons';
import { useTranslation } from 'react-i18next';
import { colors } from 'styles/colors';
import { Button } from 'components';
import { DeleteModalContainer, DeleteModalContent, DeleteModalHeader } from './styles';

interface DeleteModalProps {
  loading: boolean;
  isOpen: boolean;
  unitName: string;
  year: number;
  onClickDelete: () => void;
  onClose: () => void;
}

export function DeleteModal({
  loading,
  isOpen,
  onClose,
  onClickDelete,
  unitName,
  year,
}: Readonly<DeleteModalProps>): ReactElement | null {
  const { modalReference } = useModalControl(isOpen, onClose);
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <ModalOverlay isOpen={isOpen}>
      <DeleteModalContainer ref={modalReference}>
        <DeleteModalHeader>
          <div>
            <Trash3Icon color={colors.icon['danger-base']} size="24" />
            <h3>{t('excluirMeta')}</h3>
          </div>
          <CloseButton onClick={onClose}>
            <CloseModalX />
          </CloseButton>
        </DeleteModalHeader>
        <DeleteModalContent>
          <p>
            {t('desejaRealmenteExcluirMetaUnidadeAno', {
              unitName,
              year,
            })}
          </p>
          <div>
            <Button
              variant="neutral-ghost"
              onClick={onClose}
              type="button"
              disabled={loading}
            >
              {t('cancelar')}
            </Button>
            <Button
              variant="primary-filled"
              onClick={onClickDelete}
              type="button"
              disabled={loading}
            >
              {t('confirmar')}
            </Button>
          </div>
        </DeleteModalContent>
      </DeleteModalContainer>
    </ModalOverlay>
  );
}
